<!-- Main breakdown sidebar -->
<div id="st-breakdown-sidebar-sidebar-container" class="sidebar-container">
    <header class="sidebar-header">
        <div id="st-breakdown-sidebar-header-content" class="header-content">
            <h2>{{ 'point_breakdown_for' | translate }} {{ participantName }}</h2>
        </div>
        <button type="button" class="close-btn" (click)="onClose()" (keydown.enter)="onClose()" (keydown.space)="$event.preventDefault(); onClose()" [attr.aria-label]="'close' | translate" tabindex="0">✖</button>
    </header>
    <div id="st-breakdown-sidebar-sidebar-content" class="sidebar-content">
        <div id="st-breakdown-sidebar-event-points-container"
            *ngIf="!isLoading && eventPerformances.length > 0"
            class="event-points-container">
            <div id="st-breakdown-sidebar-event-name" class="event-name">
                <h3>{{ 'event_name' | translate }}</h3>
            </div>
            <div id="st-breakdown-sidebar-points" class="points">
                <h3>{{ 'points' | translate }}</h3>
            </div>
        </div>
        <div id="st-breakdown-sidebar-loader-container" *ngIf="isLoading" class="loader-container">
            <stupa-skeleton-loader class="w-100 p-3" [rows]="5" [columns]="3" />
        </div>
        <div id="st-breakdown-sidebar-empty-state"
            *ngIf="!isLoading && eventPerformances.length === 0"
            class="norecord d-flex flex-column align-items-center text-center w-100 justify-content-center flex-grow-1 gap-3 py-5 px-4">
            <img alt=""
                class="breakdown-empty-state-img img-fluid"
                src="../../../../assets/ranking-rating_assets/no_record_found.svg"
                [attr.alt]="'no_records_found' | translate"
            />
            <p class="no-record mb-0">{{ 'no_event_performances_available' | translate }}</p>
        </div>
        <div [id]="'st-breakdown-sidebar-event-points-data-1' + event.event_id"
            *ngFor="let event of eventPerformances; trackBy: trackByEventId"
            class="event-points-data"
            [class.is-highlighted]="event.is_highlighted"
            [style.backgroundColor]="isTemplate1 ? null : (event.is_highlighted ? 'var(--rating-breakdown-event-highlight-bg, #F4FAFF)' : 'var(--rating-breakdown-event-bg, #FFFFFF)')">
            <div id="st-breakdown-sidebar-data-row" class="data-row">
                <div id="st-breakdown-sidebar-event-data" class="event-data">
                    <div id="st-breakdown-sidebar-event-title" class="event-title">{{ event.event_name }}</div>
                    <div id="st-breakdown-sidebar-event-dates" class="event-dates">
                        <span class="date-item">{{ 'allocation' | translate }}: {{ event.allocation_date }}</span>
                    </div>
                </div>
                <div id="st-breakdown-sidebar-points-data" class="points-data">
                    <span class="points-value">{{ event.points }}</span>
                </div>
                <div class="edit-action-data">
                    <i class="bi edit-icon"
                        [ngClass]="selectedBreakdownEventId === event.event_id ? 'bi-chevron-up' : 'bi-chevron-down'"
                        (click)="toggleBreakdown(event.event_id)"></i>
                </div>
            </div>
            <div id="st-breakdown-sidebar-breakdown" class="breakdown"
                *ngIf="selectedBreakdownEventId === event.event_id" @breakdownAnimation>
                <h4>{{ 'breakdown' | translate }}</h4>
                <div id="st-breakdown-sidebar-point-breakdown-container"
                    *ngIf="mappedBreakdownDetails.length > 0"
                    class="point-breakdown-container">
                    <button type="button" (click)="onPointClick(component.labelKey, event.event_id)" (keydown.enter)="onPointClick(component.labelKey, event.event_id)" (keydown.space)="$event.preventDefault(); onPointClick(component.labelKey, event.event_id)" *ngFor="let component of mappedBreakdownDetails; trackBy: trackByLabelKey" [id]="'st-breakdown-sidebar-point-breakdown-item-' + component.labelKey" class="point-breakdown-item" [class.tournament-weight-item]="component.isTournamentWeight" [class.point-breakdown-item--active]="selectedPointKey === component.labelKey && isCategorySidebarOpen">
                        <span class="point-name">{{ component.labelKey | translate }}</span>
                        @if (component.isTournamentWeight) {
                            <span class="point-value tournament-weight-value">x{{ component.points }}</span>
                        } @else {
                            <span class="point-value">{{ component.points }} {{ 'points' | translate | lowercase }}</span>
                        }
                    </button>
                </div>
                <div id="st-breakdown-sidebar-block"
                    *ngIf="mappedBreakdownDetails.length === 0"
                    class="norecord d-flex flex-column align-items-center text-center w-100 gap-3 py-4 px-3">
                    <img alt=""
                        class="breakdown-empty-state-img breakdown-empty-state-img--sm img-fluid"
                        src="../../../../assets/ranking-rating_assets/no_record_found.svg"
                        [attr.alt]="'no_records_found' | translate"
                    />
                    <p class="no-record mb-0">{{ 'no_breakdown_details_available' | translate }}</p>
                </div>
            </div>
        </div>
    </div>
    <div id="st-breakdown-sidebar-sidebar-footer" class="sidebar-footer"></div>
</div>

<!-- Nested category breakdown sidebar (opens on point-breakdown-item click) -->
<div id="st-breakdown-sidebar-category-container"
    class="sidebar-container category-breakdown-sidebar"
    [class.open]="isCategorySidebarOpen">
    <header class="sidebar-header">
        <div id="st-breakdown-sidebar-category-header-content" class="header-content">
            <h2>{{ 'point_breakdown_for' | translate }} {{ participantName }}</h2>
        </div>
        <button type="button" class="close-btn" (click)="onClose()" (keydown.enter)="onClose()" (keydown.space)="$event.preventDefault(); onClose()" [attr.aria-label]="'close' | translate" tabindex="0">✖</button>
    </header>
    <div id="st-breakdown-sidebar-category-content" class="sidebar-content">
        <div id="st-breakdown-sidebar-category-loader" *ngIf="isBreakdownLoading" class="loader-container">
            <stupa-skeleton-loader class="w-100 p-3" [rows]="5" [columns]="3" />
        </div>
        <div id="st-breakdown-sidebar-category-detail-list"
            *ngIf="!isBreakdownLoading && categoryBreakdowns.length > 0"
            class="category-detail-list">
            <div [id]="'st-breakdown-sidebar-category-detail-' + category.category_id"
                *ngFor="let category of categoryBreakdowns; trackBy: trackByCategoryId"
                class="category-detail-section">
                <div class="category-detail-header">
                    <span class="category-detail-name">{{ category.category_name }}</span>
                </div>
                <div class="category-detail-card">
                    <button type="button" (click)="onCategoryDetailRowClick(category, 'victory_points', $event)" (keydown.enter)="onCategoryDetailRowClick(category, 'victory_points', $any($event))" (keydown.space)="$event.preventDefault(); onCategoryDetailRowClick(category, 'victory_points', $any($event))" class="category-detail-row category-detail-row--clickable victory-point-row" [class.category-detail-row--active]="isCategoryRowActive(category.category_id, 'victory_points')">
                        <span class="category-detail-label">{{ 'victory_points' | translate }}</span>
                        <span class="category-detail-value">
                            {{ getVictoryPoints(category) | number: '1.2-2' }}
                        </span>
                    </button>
                    <button type="button" (click)="onCategoryDetailRowClick(category, 'bonus_points', $event)" (keydown.enter)="onCategoryDetailRowClick(category, 'bonus_points', $any($event))" (keydown.space)="$event.preventDefault(); onCategoryDetailRowClick(category, 'bonus_points', $any($event))" class="category-detail-row category-detail-row--clickable bonus-point-row" [class.category-detail-row--active]="isCategoryRowActive(category.category_id, 'bonus_points')">
                        <span class="category-detail-label">{{ 'bonus_points' | translate }}</span>
                        <span class="category-detail-value">
                            {{ getBonusPoints(category) | number: '1.2-2' }}
                        </span>
                    </button>
                    @if (shouldShowTournamentWeight(category)) {
                        <div class="category-detail-row tournament-weight-row">
                            <span class="category-detail-label">{{ 'tournament_weight' | translate }}</span>
                            <span class="category-detail-value tournament-weight-value">
                                x{{ category.tournament_weight }}
                            </span>
                        </div>
                    }
                    <button type="button" (click)="onCategoryDetailRowClick(category, 'penalty_points', $event)" (keydown.enter)="onCategoryDetailRowClick(category, 'penalty_points', $any($event))" (keydown.space)="$event.preventDefault(); onCategoryDetailRowClick(category, 'penalty_points', $any($event))" class="category-detail-row category-detail-row--clickable penalty-row" [class.category-detail-row--active]="isCategoryRowActive(category.category_id, 'penalty_points')">
                        <span class="category-detail-label">{{ 'penalty_points' | translate }}</span>
                        <span class="category-detail-value penalty-value">
                            {{ getPenaltyDisplay(category) }}
                        </span>
                    </button>
                    <div class="category-detail-row total-row">
                        <span class="category-detail-label">{{ 'total' | translate }}</span>
                        <span class="category-detail-value total-value">
                            {{ category.total_points | number: '1.2-2' }}
                            <span class="points-unit">{{ 'pts' | translate }}</span>
                        </span>
                    </div>
                </div>
                @if (category.last_updated_at) {
                    <p class="category-last-updated">
                        {{ 'last_updated' | translate }} {{ 'on' | translate }}
                        {{ formatLastUpdated(category.last_updated_at) }}
                    </p>
                }
            </div>
        </div>
        <div id="st-breakdown-sidebar-category-empty"
            *ngIf="!isBreakdownLoading && categoryBreakdowns.length === 0"
            class="norecord d-flex flex-column align-items-center text-center w-100 justify-content-center flex-grow-1 gap-3 py-5 px-4">
            <img alt=""
                class="breakdown-empty-state-img img-fluid"
                src="../../../../assets/ranking-rating_assets/no_record_found.svg"
                [attr.alt]="'no_records_found' | translate"
            />
            <p class="no-record mb-0">{{ 'no_breakdown_details_available' | translate }}</p>
        </div>
    </div>
    <div class="sidebar-footer"></div>
</div>

<!-- Nested match-level breakdown sidebar (opens on category card click) -->
<div id="st-breakdown-sidebar-match-container"
    class="sidebar-container match-breakdown-sidebar"
    [class.open]="isMatchSidebarOpen">
    <header class="sidebar-header">
        <div id="st-breakdown-sidebar-match-header-content" class="header-content">
            <h2>{{ 'point_breakdown_for' | translate }} {{ participantName }}</h2>
        </div>
        <button type="button" class="close-btn" (click)="onClose()" (keydown.enter)="onClose()" (keydown.space)="$event.preventDefault(); onClose()" [attr.aria-label]="'close' | translate" tabindex="0">✖</button>
    </header>
    <div id="st-breakdown-sidebar-match-content" class="sidebar-content">
        <div id="st-breakdown-sidebar-match-loader" *ngIf="isMatchLoading" class="loader-container">
            <stupa-skeleton-loader class="w-100 p-3" [rows]="5" [columns]="3" />
        </div>
        <div id="st-breakdown-sidebar-match-groups"
            *ngIf="!isMatchLoading && matchBreakdownGroups.length > 0"
            class="match-breakdown-list">
            <div [id]="'st-breakdown-sidebar-match-group-' + groupIndex"
                *ngFor="let group of matchBreakdownGroups; let groupIndex = index; trackBy: trackByMatchGroupIndex"
                class="match-breakdown-group">
                <div class="match-group-header">
                    <span class="match-tournament-name">{{ tournamentNameForMatch }}</span>
                    <div class="match-initial-rating">
                        <span class="match-initial-rating-label">{{ 'initial_rating' | translate }}</span>
                        <span class="match-initial-rating-value">
                            {{ group.initial_rating | number: '1.0-0' }}
                            <span class="points-unit">{{ 'pts' | translate }}</span>
                        </span>
                    </div>
                </div>
                <div class="match-point-section">
                    <div class="match-table-header">
                        <span>{{ 'status' | translate }}</span>
                        <span>{{ 'name' | translate }}</span>
                        <span>{{ 'date' | translate }}</span>
                        <span>{{ 'score' | translate }}</span>
                        <span>{{ 'rating' | translate }}</span>
                        <span>{{ 'vp' | translate }}</span>
                        <span>{{ 'bp' | translate }}</span>
                    </div>
                    <div [id]="'st-breakdown-sidebar-match-row-' + match.match_id"
                        class="match-table-row"
                        *ngFor="let match of group.matches; trackBy: trackByMatchId">
                        <span class="match-status">{{ match.match_status }}</span>
                        <span class="match-opponent-name">{{ match.opponent_name }}</span>
                        <span class="match-date">{{ formatMatchDate(match.match_date) }}</span>
                        <span class="match-score">{{ match.score }}</span>
                        <span class="match-rating">{{ match.opponent_rating }}</span>
                        <span class="match-point-badge"
                            [class.held-point]="match.is_held"
                            (mouseenter)="match.is_held && showHoldTip($event, match.hold_reason)"
                            (mouseleave)="hideHoldTip()">{{ match.vp }}</span>
                        <span class="match-point-badge"
                            [class.held-point]="match.is_held"
                            (mouseenter)="match.is_held && showHoldTip($event, match.hold_reason)"
                            (mouseleave)="hideHoldTip()">{{ match.bp }}</span>
                    </div>
                    <div class="match-total-row">
                        <span>{{ 'victory_points_total' | translate }}</span>
                        <span class="match-total-value">
                            {{ group.total_vp | number: '1.2-2' }} {{ 'pts' | translate }}
                        </span>
                    </div>
                    <div class="match-total-row">
                        <span>{{ 'bonus_points_total' | translate }}</span>
                        <span class="match-total-value">
                            {{ group.total_bp | number: '1.2-2' }} {{ 'pts' | translate }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div id="st-breakdown-sidebar-match-empty"
            *ngIf="!isMatchLoading && matchBreakdownGroups.length === 0"
            class="norecord d-flex flex-column align-items-center text-center w-100 justify-content-center flex-grow-1 gap-3 py-5 px-4">
            <img alt=""
                class="breakdown-empty-state-img img-fluid"
                src="../../../../assets/ranking-rating_assets/no_record_found.svg"
                [attr.alt]="'no_records_found' | translate"
            />
            <p class="no-record mb-0">{{ 'no_breakdown_details_available' | translate }}</p>
        </div>
    </div>
    <div class="sidebar-footer"></div>
</div>
<div
    *ngIf="holdTip"
    id="st-breakdown-sidebar-hold-tip"
    class="hold-tip"
    [style.top.px]="holdTip.top"
    [style.left.px]="holdTip.left">
    <strong class="hold-tip-title">{{ 'match_on_hold' | translate }}</strong>
    <span *ngIf="holdTip.text" class="hold-tip-reason">{{ holdTip.text }}</span>
</div>
